import { render, staticRenderFns } from "./NieuwsMedewerkers.vue?vue&type=template&id=135c1038&scoped=true&"
import script from "./NieuwsMedewerkers.vue?vue&type=script&lang=js&"
export * from "./NieuwsMedewerkers.vue?vue&type=script&lang=js&"
import style0 from "./NieuwsMedewerkers.vue?vue&type=style&index=0&id=135c1038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c1038",
  null
  
)

export default component.exports